<script setup lang="ts">
interface Props {
  initial?: number | null
  installmentsCount?: number | null
  installmentsAmount?: number | null
}

const props = defineProps<Props>()

const hasInstallments = computed(() => props.initial || props.installmentsCount)
</script>

<template>
  <div
    v-if="hasInstallments"
    class="mt-2 w-full items-center justify-center gap-2 rounded-md border border-primary p-2 flex text-sm md:text-base"
  >
    <div
      v-if="initial"
      class="flex flex-wrap justify-center items-center leading-none"
    >
      <div class="mx-1">Inicial</div>
      <div class="font-bold text-nowrap mx-1">
        RD$
        {{
          formatCurrency({
            price: initial ?? 0,
          })
        }}
      </div>
    </div>
    <div
      v-if="initial && installmentsCount"
      class="flex items-center justify-center"
    >
      <span class="text-md icon-[ph--plus-bold]" />
    </div>
    <div
      v-if="installmentsAmount"
      class="flex flex-wrap items-center justify-center leading-none"
    >
      <div class="text-nowrap mx-1"> {{ installmentsCount }} cuotas </div>
      <div class="font-bold text-nowrap mx-1">
        RD$
        {{
          formatCurrency({
            price: installmentsAmount,
          })
        }}
      </div>
    </div>
    <div v-else-if="installmentsCount"> {{ installmentsCount }} pagos en cuotas </div>
  </div>
</template>
